import { render, staticRenderFns } from "./DoubleSystemQuizView.vue?vue&type=template&id=bbfb2828&scoped=true&"
import script from "./DoubleSystemQuizView.vue?vue&type=script&lang=js&"
export * from "./DoubleSystemQuizView.vue?vue&type=script&lang=js&"
import style0 from "./DoubleSystemQuizView.vue?vue&type=style&index=0&id=bbfb2828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfb2828",
  null
  
)

export default component.exports